// extracted by mini-css-extract-plugin
module.exports = {"shadow":"index_shadow_1ike3","itemLink":"index_itemLink_21EWe","tag_list":"index_tag_list_2Q2qQ","tag_group_name":"index_tag_group_name_1A2ou","error":"index_error_23V7d"};